export const GUEST_LINKS_NAME_MIN_LENGTH = 3;
export const GUEST_LINKS_NAME_MAX_LENGTH = 60;
